<template lang="html">
  <a class="remote-link" :href="href" target="_blank" :rel="rel">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'RemoteLink',

  props: {
    href: {
      type: String,
      required: true,
    },
    noReferrer: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    rel() {
      return this.noReferrer ? 'noopener noreferrer' : 'noopener';
    },
  },
};
</script>
